import React from 'react';
import { Box, Typography } from '@material-ui/core';

const Account: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h4">Account</Typography>
      <Typography variant="body1">Account component - To be implemented</Typography>
    </Box>
  );
};

export default Account; 